import { CoinsIcon, PackageIcon } from '@phosphor-icons/react'

import { filterNames } from '../constants'

const sectionIds = {
  product: 'product',
  exportInformation: 'exportInformation',
}

export const sections = [
  {
    label: 'Producto',
    id: sectionIds.product,
    Icon: PackageIcon,
  },
  {
    label: 'Información de exportación',
    id: sectionIds.exportInformation,
    Icon: CoinsIcon,
  },
]

export const filterTypes = [
  { label: 'Alertas pendientes', value: filterNames.missing, section: sectionIds.product },
  { label: 'País de origen', value: filterNames.country, section: sectionIds.product },
  { label: 'Peso', value: filterNames.weightLte, section: sectionIds.product },
  { label: 'Coste unitario', value: filterNames.unitCostLte, section: sectionIds.product },
  { label: 'Categoría', value: filterNames.category, section: sectionIds.product },
  { label: 'Estado', value: filterNames.productStatus, section: sectionIds.product },
  { label: 'Export price', value: filterNames.hasExportPrice, section: sectionIds.exportInformation },
  { label: 'País del export price', value: filterNames.exportPriceCountry, section: sectionIds.exportInformation },
]
